import {useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMenu, FiX} = FiIcons;
const logoUrl = 'https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvanBlZw==/62e4f25ee7ce1132fd491e120c9d2eff.jpg';
const languages = ['en', 'es', 'ca'];

export default function Navbar({copy, language, onLanguageChange}) {
  const [open, setOpen] = useState(false);
  const links = [
    {href: '#schedule', label: copy.schedule},
    {href: '#location', label: copy.location},
    {href: '#dresscode', label: copy.dresscode},
    {href: '#stay', label: copy.stay},
    {href: '#rsvp', label: copy.rsvp},
  ];
  const closeMenu = () => setOpen(false);

  return (
    <nav className="navbar">
      <a
        className="brand"
        href="#top"
        onClick={closeMenu}
        aria-label="Joan and Sofia"
      >
        <img
          src={logoUrl}
          alt="Joan & Sofia wedding logo"
          style={{height: 58, width: 58, objectFit: 'contain'}}
        />
      </a>
      <div className={`nav-links ${open ? 'nav-links-open' : ''}`}>
        {links.map((link) => (
          <a key={link.href} href={link.href} onClick={closeMenu}>
            {link.label}
          </a>
        ))}
        <div className="language-switch" aria-label="Choose language">
          {languages.map((code, index) => (
            <span key={code}>
              {index > 0 && <span aria-hidden="true"> / </span>}
              <button
                className="language-button"
                type="button"
                aria-pressed={language === code}
                onClick={() => onLanguageChange(code)}
              >
                {code.toUpperCase()}
              </button>
            </span>
          ))}
        </div>
      </div>
      <button
        className="menu-button"
        aria-label="Toggle navigation"
        onClick={() => setOpen(!open)}
      >
        <SafeIcon icon={open ? FiX : FiMenu} />
      </button>
    </nav>
  );
}